import type { IncidentClassification } from '@/shared/observability/incident-policy';

export type IncidentSinkAlertSeverity = 'critical' | 'high' | 'warning' | 'info' | 'low';

export const resolveIncidentSinkAlertSeverity = ({
    classification,
    severity,
}: {
    classification: IncidentClassification;
    severity?: string | null;
}): IncidentSinkAlertSeverity => {
    if (classification === 'operator_warning') {
        return 'warning';
    }

    switch (severity) {
        case 'fatal':
            return 'critical';
        case 'warn':
            return 'warning';
        case 'info':
            return 'info';
        case 'trace':
        case 'debug':
            return 'low';
        case 'error':
        default:
            return 'high';
    }
};
